export default {
  Index: {
    title: '汇通数科智能科技有限公司-首页',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Micromall: {
    title: '微商城',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  ChainE: {
    title: '连锁电商',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Community: {
    title: '社群分销',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  B2B2C: {
    title: 'B2B2C',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Retail: {
    title: '零售电商',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  CloudPurchase: {
    title: '云采购',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  LiveBroadcast: {
    title: '直播电商',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Finance: {
    title: '金融服务',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Cashier: {
    title: '智能收银',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Payment: {
    title: '智能支付',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Member: {
    title: '会员CRM',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Popularize: {
    title: '流量推广',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  BrandCustom: {
    title: '品牌商城定制',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  DistributeCustom: {
    title: '分销商城定制',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  ShopCustom: {
    title: '门店管理定制',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  O2OCustom: {
    title: 'O2O定制',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Supplychain: {
    title: '供应链服务',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  AgentOperation: {
    title: '代运营服务',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Cooperate: {
    title: '渠道合作',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  EcoPartner: {
    title: '生态伙伴',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Introduce: {
    title: '企业简介',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  Dynamic: {
    title: '企业动态',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcErpSystem: {
    title: '千橙ERP系统',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcCashier: {
    title: '千橙收银系统',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcDistribution: {
    title: '千橙分销系统',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcChain: {
    title: '千橙连锁系统',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcShopkeeper: {
    title: '千橙新零售系统',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcDigit: {
    title: '千橙数字人',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcShoppingMall: {
    title: '千橙微商城',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcMarketing: {
    title: '千橙会员营销系统',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcCommerce: {
    title: '千橙电商S2B2C',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcB2BChannel: {
    title: 'B2b渠道电商',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcLiveBroadcast: {
    title: '汇好看直播电商',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcTool: {
    title: '千橙RPA工具箱',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcDownload: {
    title: '产品下载聚合页',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  QcAssociation: {
    title: '汇团团社群营销系统',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
  TryModalPage: {
    title: '信息提交',
    meta: [{
      name: 'keywords',
      content: '汇通数科, SaaS, 汇通达'
    }, {
      name: 'description',
      content: '汇通数科, SaaS, 汇通达'
    }]
  },
}
